import FormInputError from "../../General/FormInputError";
import { v4 as uuidv4 } from "uuid";
import { states } from "../../../js/placeholderData/states";
import { useTranslation } from "react-i18next";

export default function BeneficiaryInfoCard({
  componentIndex,
  lastComponent,
  FACStepFourRegister,
  append,
  remove,
  errors,
}) {
  const uuid = uuidv4();
  const { t } = useTranslation();

  return (
    <div className="mt-6 grid gap-4 grid-cols-1 lg:gap-6">
      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr,1fr]">
        {componentIndex > 0 && (
          <div className="md:col-span-3">
            <button
              className="ui-btn-primary-error my-2"
              type="button"
              onClick={() => remove(componentIndex)}
            >
              {t("AgentBeneficiaryInfoCard-removeBeneficiaryButton")}
            </button>
          </div>
        )}
        <div>
          <label htmlFor={`${uuid}-fn-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-firstNameLabel")}
          </label>
          <input
            id={`${uuid}-fn-beneficiary`}
            type="text"
            placeholder={t("AgentBeneficiaryInfoCard-firstNamePlaceholder")}
            {...FACStepFourRegister(
              `beneficiaries[${componentIndex}].firstName`,
              {
                required: t(
                  "AgentBeneficiaryInfoCard-firstNameRequiredMessage",
                  {
                    index: componentIndex + 1,
                  }
                ),
              }
            )}
          />
          <FormInputError
            id={`${uuid}-fn-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.firstName?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-ln-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-lastNameLabel")}
          </label>
          <input
            id={`${uuid}-ln-beneficiary`}
            type="text"
            placeholder={t("AgentBeneficiaryInfoCard-lastNamePlaceholder")}
            {...FACStepFourRegister(
              `beneficiaries[${componentIndex}].lastName`,
              {
                required: t(
                  "AgentBeneficiaryInfoCard-lastNameRequiredMessage",
                  {
                    index: componentIndex + 1,
                  }
                ),
              }
            )}
          />
          <FormInputError
            id={`${uuid}-ln-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.lastName?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-mn-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-middleInitialLabel")}
          </label>
          <input
            id={`${uuid}-mn-beneficiary`}
            type="text"
            {...FACStepFourRegister(
              `beneficiaries[${componentIndex}].middleName`
            )}
          />
          <FormInputError
            id={`${uuid}-mn-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.middleName?.message
                : ""
            }
          />
        </div>
      </div>

      <div>
        <label htmlFor={`${uuid}-sa-beneficiary`} className="block mb-1">
          {t("AgentBeneficiaryInfoCard-mailingAddressLabel")}
        </label>
        <input
          id={`${uuid}-sa-beneficiary`}
          type="text"
          placeholder={t("AgentBeneficiaryInfoCard-mailingAddressPlaceholder")}
          {...FACStepFourRegister(
            `beneficiaries[${componentIndex}].streetAddress`
          )}
        />
        <FormInputError
          id={`${uuid}-sa-beneficiary-error`}
          errorMessage={
            errors?.beneficiaries?.length
              ? errors?.beneficiaries[componentIndex]?.streetAddress?.message
              : ""
          }
        />
      </div>

      <div>
        <label htmlFor={`${uuid}-sa2-beneficiary`} className="block mb-1">
          {t("AgentBeneficiaryInfoCard-mailingAddressLabel2")}
        </label>
        <input
          id={`${uuid}-sa2-beneficiary`}
          type="text"
          placeholder={t("AgentBeneficiaryInfoCard-mailingAddressPlaceholder2")}
          {...FACStepFourRegister(
            `beneficiaries[${componentIndex}].streetAddress2`
          )}
        />
        <FormInputError
          id={`${uuid}-sa2-beneficiary-error`}
          errorMessage={
            errors?.beneficiaries?.length
              ? errors?.beneficiaries[componentIndex]?.streetAddress2?.message
              : ""
          }
        />
      </div>
      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1.5fr,1fr,1fr]">
        <div>
          <label htmlFor={`${uuid}-city-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-cityLabel")}
          </label>
          <input
            id={`${uuid}-city-beneficiary`}
            type="text"
            placeholder={t("AgentBeneficiaryInfoCard-cityLabel")}
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].city`)}
          />
          <FormInputError
            id={`${uuid}-city-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.city?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-state-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-stateLabel")}
          </label>
          <select
            id={`${uuid}-state-mailing`}
            placeholder={t("AgentBeneficiaryInfoCard-stateLabel")}
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].state`)}
          >
            <option value="">State</option>
            {states.map((state, idx) => (
              <option
                value={state.abbreviation}
                key={`state - ${state.name} - ${idx}`}
              >
                {state.name}
              </option>
            ))}
          </select>

          <FormInputError
            id={`${uuid}-state-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.state?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-zip-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-zipLabel")}
          </label>
          <input
            id={`${uuid}-zip-beneficiary`}
            type="text"
            placeholder={t("AgentBeneficiaryInfoCard-zipPlaceholder")}
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].zip`, {
              pattern: {
                value: /^\d{5}$/,
                message: t("AgentBeneficiaryInfoCard-zipPatternMessage"),
              },
              maxLength: {
                value: 5,
                message: t("AgentBeneficiaryInfoCard-maxLengthMessage"),
              },
            })}
          />
          <FormInputError
            id={`${uuid}-zip-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.zip?.message
                : ""
            }
          />
        </div>
      </div>

      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
        <div>
          <label htmlFor={`${uuid}-phone-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-phoneNumberLabel")}
          </label>
          <input
            id={`${uuid}-phone-beneficiary`}
            aria-describedby={`${uuid}-phone-beneficiary-note`}
            type="text"
            placeholder={t("AgentBeneficiaryInfoCard-phoneNumberPlaceholder")}
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].phone`)}
          />
          <FormInputError
            id={`${uuid}-phone-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.phone?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-email-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-emailAddressLabel")}
          </label>
          <input
            id={`${uuid}-email-beneficiary`}
            type="text"
            placeholder={t("AgentBeneficiaryInfoCard-emailAddressPlaceholder")}
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].email`)}
          />
          <FormInputError
            id={`${uuid}-email-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.email?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-dob-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-DOBLabel")}
          </label>
          <input
            id={`${uuid}-dob-beneficiary`}
            type="date"
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].dob`)}
          />
          <FormInputError
            id={`${uuid}-email-dob-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.dob?.message
                : ""
            }
          />
        </div>
      </div>
      {/* LAST ROW ON BENEFICIARY STEP */}
      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,2fr]">
        <div>
          <label htmlFor={`${uuid}-ssn-beneficiary`} className="block mb-1">
            {t("AgentBeneficiaryInfoCard-socialSecurityLabel")}
          </label>
          <input
            id={`${uuid}-ssn-beneficiary`}
            type="text"
            aria-describedby={`${uuid}-ssn-beneficiary-note`}
            placeholder={t(
              "AgentBeneficiaryInfoCard-socialSecurityPlaceholder"
            )}
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].ssn`)}
          />
          <FormInputError
            id={`${uuid}-ssn-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.ssn?.message
                : ""
            }
          />
        </div>

        <div>
          <label
            htmlFor={`${uuid}-relationship-beneficiary`}
            className="block mb-1"
          >
            {t("AgentBeneficiaryInfoCard-relationshipBeneficiaryLabel")}
          </label>

          <select
            id={`${uuid}-relationship-beneficiary`}
            {...FACStepFourRegister(
              `beneficiaries[${componentIndex}].relationship`,
              {
                required: t(
                  "AgentBeneficiaryInfoCard-relationshipBeneficiaryRequiredMessage",
                  {
                    index: componentIndex + 1,
                  }
                ),
              }
            )}
          >
            <option value="">
              {t("AgentBeneficiaryInfoCard-relationshipBeneficiarySelectLabel")}
            </option>
            <option value="owner">
              {t(
                "AgentBeneficiaryInfoCard-relationshipBeneficiarySelect-option1"
              )}
            </option>
            <option value="spouse">
              {t(
                "AgentBeneficiaryInfoCard-relationshipBeneficiarySelect-option2"
              )}
            </option>
            <option value="child">
              {t(
                "AgentBeneficiaryInfoCard-relationshipBeneficiarySelect-option3"
              )}
            </option>
            <option value="dependent">
              {t(
                "AgentBeneficiaryInfoCard-relationshipBeneficiarySelect-option4"
              )}
            </option>
            <option value="other">
              {t(
                "AgentBeneficiaryInfoCard-relationshipBeneficiarySelect-option5"
              )}
            </option>
          </select>

          <FormInputError
            id={`${uuid}-relationship-beneficiary`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.relationship?.message
                : ""
            }
          />
        </div>
      </div>

      {lastComponent && (
        <div className="flex justify-start">
          <button
            className="ui-btn-secondary mt-4"
            type="button"
            onClick={() => append({ firstName: "" })}
          >
            {t("AgentBeneficiaryInfoCard-anotherBeneficiaryButtonLabel")}
          </button>
        </div>
      )}
    </div>
  );
}
